<mat-dialog-content>
    <div class="uber-wrap">
        <div class="text-center space-between">
            <div class="space-between logo-wrap w-100">
                <img
                    src="assets/images/Uber-Driver-App-logo.png"
                    alt="uber logo"
                    class="logo-img"
                />
                <button type="button" mat-icon-button mat-dialog-close aria-label="Dismiss and close">
                  <mat-icon>repeat</mat-icon>
                </button>
                <span class="pink-cont">
                    <img
                        src="assets/images/circle-octo-logo.svg"
                        alt="octopus logo"
                        class="logo-img octo-img"
                    />
                </span>
            </div>
            <div class="w-100 border-top">
                <p>
                    If you change your mind, go to “Account” > “Driver Info” >
                    “Third-Party Linked Accounts” to link your Uber account.
                </p>
                <button class="btn" mat-dialog-close id="uber-linklater-button">Ok, I got it</button>
            </div>
        </div>
    </div>
</mat-dialog-content>
